module.exports = __webpack_public_path__ + "static/img/IMG_20151122_215348.3313ce93.jpg";